import { Botao } from '@mymaxx/ui';
import { useEffect } from 'react';
import { Link, useNavigate } from 'react-router';
import { tentarRefresh } from '../lib/api';
import { useSessao } from '../lib/sessao';

/**
 * Porta de entrada do cliente: falar com um atendente sem login, ou entrar na conta.
 *
 * As duas portas são de verdade — o atendimento como visitante abre protocolo, passa pela
 * triagem e entra na fila igual ao de quem tem conta. A conta serve para ver o histórico.
 */
export function BoasVindas() {
  const { accessToken, restaurando, concluirRestauracao } = useSessao();
  const navegar = useNavigate();

  // Quem já entrou antes volta direto para a conta (cookie de refresh, 30 dias).
  useEffect(() => {
    if (!restaurando) return;
    void tentarRefresh().finally(concluirRestauracao);
  }, [restaurando, concluirRestauracao]);

  useEffect(() => {
    if (accessToken) navegar('/conta', { replace: true });
  }, [accessToken, navegar]);

  return (
    <main className="flex min-h-dvh flex-col items-center justify-center gap-6 px-6 text-center">
      {/* A logo já traz o nome escrito; repeti-lo em texto embaixo seria eco. */}
      <img src="/logo.png" alt="MyMAXX" className="size-32" width={128} height={128} />
      <p className="text-neutral-600 dark:text-neutral-400">Atendimento da MAXX Conectado</p>
      <div className="w-full max-w-xs space-y-3">
        <Link to="/atendimento" className="block">
          <Botao className="w-full">Iniciar atendimento</Botao>
        </Link>
        <Link to="/entrar" className="block">
          <Botao variante="secundario" className="w-full">
            Acessar minha conta
          </Botao>
        </Link>
      </div>
      <p className="max-w-xs text-xs text-neutral-500">
        Na sua conta você acompanha os atendimentos anteriores e seus serviços.
      </p>
      {/* Ao iniciar um atendimento o cliente aceita o aviso; o link tem de estar aqui,
          onde ele decide, e não escondido depois. */}
      <Link to="/privacidade" className="text-xs text-neutral-500 underline">
        Aviso de privacidade
      </Link>
    </main>
  );
}
